enum TextStyleType {
  COLOR = "color",
  FONT = "font",
  DECORATION = "decoration",
  SIZE = "size",
}

export default TextStyleType;
